import React, { useCallback, useEffect, useState } from 'react';
import { ChangeRegionDialog, ChangeRegionSuccessDialog } from '@colonist/clientforge';
import { clientI18n, clientIntl } from '../../ClientI18n.ts';
import { UIAjaxWrapper } from '../../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../network/UIAPIEndpoints.ts';
import { tabCommunication } from '../../EntryShared.ts';
import { TabCommunicationEvent } from '../../tab_communication/TabCommunication.ts';
/** Bridges ChangeRegionDialog to legacy globals: fetches regions, posts the change, shows the success dialog. */ export const ChangeRegionDialogContainer = ({ open, onClose })=>{
    const [regions, setRegions] = useState(undefined);
    const [successOpen, setSuccessOpen] = useState(false);
    useEffect(()=>{
        if (!open) return;
        if (regions !== undefined) return;
        void (async ()=>{
            const data = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiGetRegions());
            if ((data === null || data === void 0 ? void 0 : data.json) == undefined) return;
            const { regions: serverRegions } = data.json;
            setRegions(toClientRegions(serverRegions));
        })();
    }, [
        open,
        regions
    ]);
    const onSubmit = useCallback((selection)=>{
        onClose();
        void submitChange(selection, ()=>setSuccessOpen(true));
    }, [
        onClose
    ]);
    const reloadWebsite = useCallback(()=>{
        window.location.reload();
        tabCommunication.sendEvent(TabCommunicationEvent.ReloadWebsite);
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ChangeRegionDialog, {
        open: open,
        loading: regions === undefined,
        regions: regions !== null && regions !== void 0 ? regions : [],
        onCancel: onClose,
        onSubmit: onSubmit
    }), /*#__PURE__*/ React.createElement(ChangeRegionSuccessDialog, {
        open: successOpen,
        onConfirm: reloadWebsite
    }));
};
const toClientRegions = (serverRegions)=>{
    const result = [];
    for (const region of serverRegions){
        const countryName = clientIntl.getCountryName(region.countryCode);
        if (countryName == undefined) continue;
        result.push({
            continentCode: region.continentCode,
            continentName: clientI18n.t(`strings:leaderboardPage.tabs.continents.${region.continentCode}`),
            countryCode: region.countryCode,
            countryName: countryName,
            regionCode: region.regionCode,
            regionName: region.regionName
        });
    }
    return result;
};
const submitChange = async (selection, onSuccess)=>{
    const payload = {
        continentCode: selection.continentCode === '' ? undefined : selection.continentCode,
        countryCode: selection.countryCode === '' ? undefined : selection.countryCode,
        stateCode: selection.regionCode === '' ? undefined : selection.regionCode
    };
    const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiChangeRegion(), undefined, payload);
    if (response == undefined) return;
    if (!response.isSuccess) return;
    onSuccess();
};
